import React, { ReactNode, useContext, useEffect } from 'react';
import classNames from 'classnames';

import { TabContext } from './TabContext';

interface IProps {
  value: number | string;
  children: string | ReactNode;
  active?: boolean;
}

function Tab({ value, children, active }: IProps) {
  const { id, value: activeValue, onChange } = useContext(TabContext);

  useEffect(() => {
    if (active) {
      onChange(value);
    }
  }, []);

  const isSelected = value === activeValue;
  const className = classNames('novoTab', { 'novoTab--selected': isSelected });
  return (
    <button
      id={`tab-${id}-${value}`}
      className={className}
      type="button"
      role="tab"
      aria-selected={isSelected}
      aria-controls={`panel-${id}-${value}`}
      onClick={() => onChange(value)}
    >
      {children}
    </button>
  );
}

export default Tab;
